import type { AxiosInstance } from 'axios';
import type { Viewer } from '@/types';

export interface RegisterDto {
  user: {
    email: string;
    password: string;
    displayName: string;
  };
  tenant: {
    companyName: string;
    marketingProperties?: {
      companySize?: string;
      department?: string;
      phoneNumber?: string;
    };
  };
}

export interface LoginDto {
  email: string;
  password: string;
}

export interface ChangePasswordDto {
  oldPassword: string;
  newPassword: string;
}

// TODO: provide correct type
export type LoginResponse = unknown;
export type ChangePasswordResponse = unknown;

class AuthService {
  private readonly client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  register(registerDto: RegisterDto): Promise<Viewer> {
    return this.client
      .post<Viewer>('/apis/auth/register', registerDto)
      .then(({ data }) => {
        return data;
      });
  }

  login(loginDto: LoginDto): Promise<LoginResponse> {
    return this.client
      .post<LoginResponse>('/apis/auth/login', loginDto)
      .then(({ data }) => {
        return data;
      });
  }

  async changePassword(changePasswordDto: ChangePasswordDto): Promise<void> {
    await this.client.post<ChangePasswordResponse>(
      '/apis/auth/change-password',
      changePasswordDto
    );
  }

  async me(): Promise<Viewer> {
    const response = await this.client.get<Viewer>('/apis/auth/me');

    return response.data;
  }

  async requestPasswordReset(email: string): Promise<void> {
    await this.client.post('/apis/auth/password/reset/request', { email });
  }

  async passwordResetSubmit(
    newPassword: string,
    passwordResetToken: string
  ): Promise<void> {
    await this.client.patch('/apis/auth/password/reset/submit', {
      newPassword,
      token: passwordResetToken,
    });
  }
}

export default AuthService;
